/**
 * 9F Game SDK - 用于平台大厅与内嵌游戏（如 Web 网页、iframe 或 WebView）之间的安全事件通讯
 */
export type GameSdkRequest =
  | { type: 'GAME_READY' }
  | { type: 'PLACE_BET'; currency: string; amount: number }
  | { type: 'CLAIM_WIN'; currency: string; amount: number; roundId: string }
  | { type: 'GET_BALANCE'; currency: string };

export type GameSdkResponse =
  | { type: 'BALANCE_UPDATE'; currency: string; balance: number }
  | { type: 'BET_RESULT'; success: boolean; balance?: number; error?: string }
  | { type: 'SETTLEMENT_RESULT'; success: boolean; balance?: number; error?: string };

export class GameSDK {
  private targetOrigin: string;

  constructor(targetOrigin: string = '*') {
    this.targetOrigin = targetOrigin;
  }

  // 1. 发送下注请求给平台
  public placeBet(currency: string, amount: number) {
    this.sendMessage({ type: 'PLACE_BET', currency, amount });
  }

  // 2. 发送结算请求给平台
  public claimWin(currency: string, amount: number, roundId: string) {
    this.sendMessage({ type: 'CLAIM_WIN', currency, amount, roundId });
  }

  // 3. 查询当前余额
  public requestBalance(currency: string) {
    this.sendMessage({ type: 'GET_BALANCE', currency });
  }

  // 4. 通知平台游戏加载完毕
  public notifyReady() {
    this.sendMessage({ type: 'GAME_READY' });
  }

  // 5. 监听平台发回的响应事件
  public onMessage(callback: (event: GameSdkResponse) => void): () => void {
    const handler = (event: MessageEvent) => {
      // 在生产环境可以校验 event.origin
      const data = event.data;
      if (data && typeof data === 'object' && 'type' in data) {
        callback(data as GameSdkResponse);
      }
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }

  // 底层通信发送方法
  private sendMessage(message: GameSdkRequest) {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(message, this.targetOrigin);
    } else if ((window as any).ReactNativeWebView) {
      // 兼容 React Native + Expo App 通信
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
    } else {
      // 单独浏览器窗口模式发送回自身，供本地大厅直连测试
      window.postMessage(message, this.targetOrigin);
    }
  }
}
